import classNames from 'classnames';
import React from 'react';
import { Button as WixButton, ButtonProps } from '@wix/design-system';

import Icon, { IconNames } from '../icon/icon';

import styles from './button.scss';

export const Button = ({ children, prefixIcon, ...props }: ButtonProps) => {
  return (
    <WixButton skin="standard" {...props}>
      {prefixIcon && prefixIcon}
      {children}
    </WixButton>
  );
};

export enum EmptyButtonTheme {
  Empty = '',
  Redtext = 'redtext',
}

interface EmptyButtonProps {
  children?: any;
  className?: string;
  prefixIcon?: IconNames;
  iconFontSize?: number;
  theme?: EmptyButtonTheme;
  dataHook?: string;
  onClick?: any;
  disabled?: boolean;
}

export const EmptyButton = ({
  children,
  prefixIcon,
  iconFontSize,
  theme = EmptyButtonTheme.Empty,
  className,
  dataHook,
  ...props
}: EmptyButtonProps) => {
  const buttonClassNames = classNames(
    styles.emptyButton,
    styles[`${theme}-theme`],
    className,
  );
  return (
    <div {...props} className={buttonClassNames} data-hook={dataHook}>
      {prefixIcon && (
        <Icon
          name={prefixIcon}
          className={styles.prefixIcon}
          fontSize={iconFontSize}
        />
      )}
      {children}
    </div>
  );
};

export default Button;
